export default "__VITE_ASSET__Pvb7vo6M__"